module.exports = __webpack_public_path__ + "static/img/control01.4e77b12.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trackplus_2021/control01.png
// module id = tu9c
// module chunks = 1